import { useIntl } from 'react-intl'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowLuxPlusNonMemberPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import Group from 'components/utils/Group'
import { getExperienceTileSaleUnit } from 'lib/experiences/getExperienceTileSaleUnit'
import { getOfferValueDisplayVisibility } from 'lib/offer/getOfferDisplayPricing'

interface MappedProps {
  isLuxPlusEnabled: boolean
}

interface Props extends MappedProps {
  totalPrice?: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  discountPercentage?: number
  isFromPrice: boolean
  showFromCaption?: boolean
  ticketUnitLabel: string
  size?: 'S' | 'L' | 'M'
  nonMemberPriceSize?: 'L' | 'M'
  discountMemberPercentage?: number
}

function ExperienceTilePrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    discountPercentage,
    isFromPrice,
    showFromCaption = true,
    ticketUnitLabel,
    isLuxPlusEnabled,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props
  const intl = useIntl()

  const fromCaption = intl.formatMessage({
    id: 'EAQ_GV7KRwveLWB08EmL',
    defaultMessage: 'From',
  })
  const totalLabel = intl.formatMessage({
    id: 'whMf0sOzbI-AWwhc2zR7',
    defaultMessage: 'total',
  })
  const saleUnit = getExperienceTileSaleUnit({ isFromPrice, ticketUnitLabel, totalLabel })
  const discountType = isFromPrice ? 'estimate' : 'exact'
  const {
    shouldShowDiscount: shouldShowMemberDiscount,
  } = getOfferValueDisplayVisibility({ discountPercent: discountMemberPercentage })
  const {
    shouldShowDiscount,
    shouldShowValue,
  } = getOfferValueDisplayVisibility({
    discountPercent: discountPercentage,
    value: totalGrossPrice,
  })

  if (isLuxPlusEnabled && totalMemberPrice) {
    return (
      <>
        {isFromPrice && showFromCaption && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size={size}
          memberPrice={totalMemberPrice}
          saleUnit={saleUnit}
        />
        {!!totalPrice && (
          <PriceRowLuxPlusNonMemberPrice
            nonMemberPrice={totalPrice}
          />
        )}
        {!!totalGrossPrice && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={shouldShowMemberDiscount ? discountMemberPercentage : undefined}
          discountType={discountType}
        />}
      </>
    )
  }

  if (!totalPrice) return null

  return (
    <>
      {isFromPrice && showFromCaption && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
      <Group direction="horizontal" gap={8} wrap="wrap" verticalAlign="baseline">
        <PriceRowPrice
          size={size}
          price={totalPrice}
          saleUnit={saleUnit}
          wrap="word-wrap"
        />
        {shouldShowValue && totalGrossPrice !== undefined && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={shouldShowDiscount ? discountPercentage : undefined}
          discountType={discountType}
        />}
      </Group>
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isLuxPlusEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(ExperienceTilePrices)
